<template>
	<section v-if="content.list.length > 0" class="itv-short-list">
		<h2 class="itv-short-list__title" v-html="content.title"></h2>
		<swiper
			class="itv-short-list__slider"
			:modules="modules"
			:slides-per-view="1"
			:space-between="16"
			:breakpoints="{
				600: { slidesPerView: 2 },
				1200: { slidesPerView: 3 },
			}"
			:pagination="true"
		>
			<swiper-slide
				v-for="(item, i) in content.list"
				:key="i"
				class="itv-short-list__item"
			>
				<card :content="item" />
			</swiper-slide>
		</swiper>
		<primary-button class="itv-short-list__btn" :content="link" />
	</section>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Pagination } from 'swiper'
import Card from './Card'
import PrimaryButton from '../ui/PrimaryButton'
import 'swiper/css'
import 'swiper/css/pagination'

export default {
	name: 'VacanciesShortList',
	components: {
		Swiper,
		SwiperSlide,
		Card,
		PrimaryButton,
	},
	props: {
		content: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			link: {
				text: 'Все вакансии',
				btnColorType: 'transparent',
				href: '/career/vacancies/',
			},
		}
	},
	setup() {
		return {
			modules: [Pagination],
		}
	},
}
</script>
